import type { LngLat, LngLatBounds, Map as MapboxMap } from 'mapbox-gl';

/**
 * Object to store map location data and zoom.
 */
class MapPosition {
    center: LngLat;
    /** MapService crea la posicion inicial solo con centro y zoom. */
    zoom?: number;
    bounds?: LngLatBounds;
    bearing: number
    
    constructor(center: LngLat, zoom?: number, bounds?: LngLatBounds, bearing = 0) {
      this.center = center;
      this.zoom = zoom;
      this.bounds = bounds;
      this.bearing = bearing;
    }
    
    /**
     * Build from Mapbox Map
     */
    static fromMap(map: MapboxMap): MapPosition {
        return new MapPosition(map.getCenter(), map.getZoom(), map.getBounds(), map.getBearing());
    }
    
    /**
     * Convert to list (for destructuring).
     *
     * Usage: [lon, lat, zoom] = this.toList();
     */
    toList() {
      return [this.center.lng, this.center.lat, this.zoom];
    }
}

export default MapPosition;
